import React, { useState } from "react";

export default function WeatherTemp(props){
    const [unit, setUnit] = useState("Celsius");

    function convertToF(event){
        event.preventDefault();
        setUnit("Fahrenheit");
    }

    function convertToC(event){
        event.preventDefault();
        setUnit("Celsius");
    }
    
    
    if (unit === "Celsius"){
        return(
            <div className="col-4 tempDisplay align-self-center">
               <p className="temp">{props.celsius}<span class="degree">°</span></p>
               <p className="measures"><span class="selected">Celsius</span> | <a href="/" onClick={convertToF}>Fahrenheit</a></p>
                <hr></hr>
                <p className="extraData">Humidity: {props.humidity}% | Wind: {props.wind}km/h</p>
            </div>
        )
    } else {
        let fahrenheit = Math.round((props.celsius * 9/5) + 32);
        return (
<           div className="col-4 tempDisplay align-self-center">
               <p className="temp">{fahrenheit}<span class="degree">°</span></p>
               <p className="measures"><a href="/" onClick={convertToC}> Celsius</a> | <span class="selected">Fahrenheit</span></p>
                <hr></hr>
                <p className="extraData">Humidity: {props.humidity}% | Wind: {props.wind}km/h</p>
            </div>
        )
    }

    
}